import React from 'react';
import { Outlet } from 'react-router-dom';
import { Shield } from 'lucide-react';
import SuperAdminNavbar from './SuperAdminNavbar';

type SuperAdminLayoutProps = {
  children?: React.ReactNode;
};

/**
 * Layout specifically for superadmin pages
 */
const SuperAdminLayout: React.FC<SuperAdminLayoutProps> = ({ children }) => {
  // Debug log to verify rendering
  console.log("SuperAdminLayout: Rendering superadmin layout");
  
  return (
    <div className="flex min-h-screen flex-col">
      {/* Header with superadmin indicator */}
      <header className="sticky top-0 z-40 border-b bg-yellow-50">
        <div className="flex h-16 items-center justify-between px-4">
          <div className="flex items-center gap-2">
            <Shield className="h-6 w-6 text-yellow-600" />
            <span className="text-xl font-bold text-yellow-800">Hivetivity Platform Admin</span>
          </div>
          <nav className="flex items-center gap-4">
            {/* Placeholder for user menu, notifications, etc. */}
          </nav>
        </div>
      </header>
      
      <div className="flex flex-1">
        {/* Sidebar navigation */}
        <SuperAdminNavbar />
        
        {/* Main content area */}
        <main className="flex-1 overflow-y-auto bg-gray-50">
          {children || <Outlet />}
        </main>
      </div>
    </div>
  );
};

export default SuperAdminLayout; 